import { get } from "axios";

export const getBouts = () => new Promise(
  (resolve, reject) =>
    get('https://jabforms.com/WomensWinterBoxCup2023/endpoints/boutnumbers.php')
      .then(res => resolve(res.data))
      .catch(err => reject(err.response)),
);